import { render, staticRenderFns } from "./HeaderTunnel.vue?vue&type=template&id=26b7bbaa&"
import script from "./HeaderTunnel.vue?vue&type=script&lang=js&"
export * from "./HeaderTunnel.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTunnel.vue?vue&type=style&index=0&id=26b7bbaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContinueMyShopping: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ContinueMyShopping.vue').default,BrandLogo: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BrandLogo.vue').default,IconCart: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/IconCart.vue').default})
